import path from 'path';
import {Plugins} from '@packages/systems/wfdl';
import {CodeIsland} from './CodeIsland';
import {
  ElementCodeCompIcon,
  AddPanelCodeCompIcon,
} from '@packages/systems/spring';
// eslint-disable-next-line webflow/no-dangerous-imports
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';

const CodeIsland_Medium = wrapAddPanelIcon(AddPanelCodeCompIcon);

export {
  useCodeIslandCustomElementState,
  useReloadCodeIslandCustomElement,
  useIncrementCodeIslandRefreshCounter,
  useLocalDevOverrideActions,
} from './siteModules/CodeIslandCustomElementStoreHooks';

export {default as CodeIslandCustomElementStore} from './siteModules/CodeIslandCustomElementStore';

// Redirects a real component's bundle to a local dev server's, client-side only.
export {
  setLocalDevOverride,
  getLocalDevOverride,
  clearLocalDevOverrides,
  type LocalDevOverrideTarget,
} from './siteModules/localDevOverrideRegistry';

export {type CodeIslandState} from './CodeIslandSharedUtils';

export const plugin = Plugins.PrivilegedPlugin({
  atoms: {
    CodeIsland,
  },
  icons: {
    CodeIsland: ElementCodeCompIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    CodeIsland_Medium,
  },

  siteModules: [
    {
      filePaths: [
        path.resolve(__dirname, 'siteModules/webflow-code-island.js'),
      ],
      bundleIf: {
        type: 'node',
        test: ({type}) => type === 'CodeIsland',
      },
    },
  ],
});
